import { Api } from './Api'

class InvoiceLine {
  getEndPoint (ocr) {
    return fetch(`${Api.getBaseUrl()}invoiceline/${ocr}`, Api.getOptions())
  }
}

export default InvoiceLine
